import { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  en: {
    // Common
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    search: 'Search',
    loading: 'Loading...',
    noData: 'No data',
    all: 'All',
    total: 'Total',
    units: 'Units',
    actions: 'Actions',
    status: 'Status',
    date: 'Date',
    month: 'Month',
    
    // Navigation
    dashboard: 'Dashboard',
    aptekaControl: 'Partner Account',
    ordersNav: 'Orders',
    warehouseOrders: 'Warehouse Orders',
    purchaseOrders: 'Purchase Orders',
    brain: 'Brain',
    autopilot: 'Autopilot',
    warehouse: 'Warehouse',
    deliveries: 'Deliveries & Invoices',
    payments: 'Payments & Credit',
    paymentCalendar: 'Payment Calendar',
    moneyControl: 'Money Control',
    ledger: 'Ledger',
    returns: 'Returns',
    orders: 'Orders',
    lowStockAlerts: 'Low Stock Alerts',
    products: 'Products',
    inventoryRisk: 'Inventory Risk',
    sequenceAudit: 'Sequence Audit',
    telegramAudit: 'Telegram Audit',
    catalog: 'Catalog',
    companyCatalog: 'Company Catalog',
    bulkImport: 'Bulk Import',
    myCatalog: 'My Catalog',
    districtSummary: 'District Summary',
    growth: 'Growth',
    shareCodeAnalytics: 'Share Code Analytics',
    rolesPermissions: 'Roles & Permissions',
    monthClosing: 'Month Closing',
    monthOpening: 'Month Opening',
    monthControl: 'Month Control',
    auditLog: 'Audit Log',
    exceptions: 'Exceptions',
    platformAdmin: 'Platform Admin',
    controlRoom: 'Control Room',
    allWorkspaces: 'All Workspaces',
    companies: 'Companies',
    pharmacies: 'Pharmacies',
    partners: 'Partners',
    tickets: 'Tickets',
    backup: 'Backup',
    pharmacyDashboard: 'Pharmacy Dashboard',
    partnerAccounts: 'Partner Accounts',
    productIntelligence: 'Product Intelligence',
    reliabilityScores: 'Reliability Scores',
    aiInsights: 'AI Insights',
    mrDashboard: 'Medical Rep Dashboard',
    connections: 'Connections',
    subscription: 'Subscription',
    checklist: 'Checklist',
    diary: 'Diary',
    settings: 'Settings',
    notifications: 'Notifications',
    messages: 'Messages',
    operations: 'Operations',
    intelligence: 'Intelligence',
    
    // Dashboard
    totalAptekas: 'Total Pharmacies',
    totalProducts: 'Total Products',
    totalDeliveries: 'Total Deliveries',
    totalPayments: 'Total Payments',
    monthlyPR: 'Monthly Performance',
    unpaidBalance: 'Unpaid Balance',
    
    // Apteka Control
    selectApteka: 'Select Pharmacy',
    selectMonth: 'Select Month',
    oldCT: 'Opening Stock',
    delivery: 'Delivery',
    transferIn: 'T.In',
    transferOut: 'T.Out',
    allUnits: 'All',
    summa: 'Summa',
    ctEntry: 'Stock Count',
    pr: 'Perf.',
    prSumma: 'Performance Total',
    newDelivery: 'New Delivery',
    product: 'Product',
    carryFwd: 'Carry Fwd',
    transfer: 'Transfer',
    sold: 'Sold',
    saved: 'Saved',
    notSaved: 'Not Saved',
    clickSave: 'click Save below',
    monthClosed: 'Month Closed',
    monthOpen: 'Month Open',
    paymentSummary: 'Payment Summary',
    openingBalance: 'Opening Balance',
    totalPR: 'Total Performance',
    discount: 'Discount',
    netPayable: 'Net Payable',
    totalPaid: 'Total Paid',
    balanceDue: 'Balance Due',
    deliverySuggestions: 'Delivery Suggestions',
    daysStock: 'Days Stock',
    suggested: 'Suggested',
    urgent: 'Urgent',
    p2pReminder: 'Inter-Pharmacy Reminder',
    promiseDate: 'Promise Date',
    note: 'Note',
    phone: 'Phone',
    recentEdits: 'Recent Edits',
    useToAdd: 'Use + to add',
    noDeliveries: 'No deliveries',
    editQuantity: 'Edit quantity',
    
    // Deliveries
    deliveryLog: 'Delivery Log',
    invoiceRegister: 'Invoice Register',
    deliveryPriority: 'Delivery Priority',
    invoiceNo: 'Invoice No',
    amount: 'Amount',
    
    // Payments
    paymentHistory: 'Payment History',
    addPayment: 'Add Payment',
    paymentMethod: 'Payment Method',
    cash: 'Cash',
    transfer: 'Transfer',
    
    // Diary
    notes: 'Notes',
    tasks: 'Tasks',
    visits: 'Visits',
    activityLog: 'Activity Log',
    addNote: 'Add Note',
    addTask: 'Add Task',
    logVisit: 'Log Visit',
    pendingTasks: 'Pending Tasks',
    overdue: 'Overdue',
    dueDate: 'Due Date',
    priority: 'Priority',
    low: 'Low',
    medium: 'Medium',
    high: 'High',
    completed: 'Completed',
    pending: 'Pending',
    
    // Settings
    users: 'Users',
    roles: 'Roles',
    dataManagement: 'Data Management',
    language: 'Language',
    
    // Filters
    selectCountry: 'Select Country',
    allCountries: 'All Countries',
    selectState: 'Select State',
    selectDistrict: 'Select District',
    allStates: 'All States',
    allDistricts: 'All Districts',

    // Layout extras
    theme: 'Theme',
    collapse: 'Collapse',
    logOut: 'Log out',
    role: 'Role',

    // Dashboard extras
    activeAptekas: 'Active Pharmacies',
    deliveredValue: 'Delivered Value',
    prValue: 'Performance Value',
    bonusValue: 'Bonus Value',
    liveCTValue: 'Current Stock Value',
    liveCTUnits: 'Current Stock Units',
    collectionPercent: 'Collection %',
    prUnits: 'Performance Rating',
    financialOverview: 'Financial Overview',
    collectionStatus: 'Collection Status',
    exportCSV: 'Export CSV',
    executiveOverview: 'Executive overview for selected state & month',
    editsLocked: 'Edits are locked',
    editsActive: 'Edits are active',
    alerts: 'Alerts',
    p2pReminders: 'Inter-Pharmacy Payment Reminders',
    dueOverdue: 'Due/Overdue',
    noPaymentData: 'No payment data',
    noDataAvailable: 'No data available',
    addDataToSee: 'Add pharmacies, products, and stock data to see the dashboard',
    warehouseForecastRisk: 'Warehouse Forecast Risk',
    lowStockAptekas: 'Low Stock Pharmacies',
    lowPenetrationProducts: 'Low Penetration Products',
    productsAtRisk: 'Products at risk of shortage',
    aptekasNeedDelivery: 'Pharmacies need delivery urgently',
    productsLowPen: 'Products in <30% pharmacies',
    topAptekasPR: 'Top 5 Pharmacies by Performance',
    topAptekasUnpaid: 'Top 5 Pharmacies by Unpaid',
    topProductsPR: 'Top 5 Products by Performance',
    topProductsBonus: 'Top 5 Products by Bonus Value',
    name: 'Name',
    value: 'Value',

    // Apteka Control extras
    aptekaControlPanel: 'Partner Account Panel',
    stockSalesPayment: 'Stock, sales & payment management',
    locked: 'Locked',
    apteka: 'Pharmacy',
    district: 'District',
    cleared: 'Cleared',
    deliveryValue: 'Delivery Value',
    nextOldCT: 'Next Opening Stock',
    ctCarryInfo: 'Current Stock carries forward as Opening Stock for next month. Finalized at Month Closing.',
    recordPayment: 'Record Payment',
    soldPR: 'Sold (Performance)',
    afterDiscount: 'After discount',
    openingBal: 'Opening Bal.',
    fromPrevMonth: 'From prev month',
    payable: 'Payable',
    paymentPlusOpening: 'Payment + Opening',
    paid: 'Paid',
    collected: 'collected',
    opensNextMonth: 'Opens next month',
    allClear: 'All clear',
    saveChanges: 'Save Changes',
    noProductsFound: 'No products found. Add products in Catalog first.',
    gps: 'GPS',
    warehouseSource: 'Warehouse Source',
    selectProduct: 'Select product',
    price: 'Price',
    quantity: 'Quantity',
    addProduct: 'Add Product',
    createDelivery: 'Create Delivery',
    noDeliveriesMonth: 'No deliveries this month',
    noInvoicesMonth: 'No invoices this month',
    noPaymentsMonth: 'No payments recorded this month',
    mode: 'Mode',
    reference: 'Reference',
    downloadPDF: 'Download PDF',
    print: 'Print',
    saving: 'Saving...',
    failedToLoad: 'Failed to load data',
    allSaved: 'All Saved',
    recentDeliveryEdits: 'Recent Delivery Edits',
    reason: 'Reason',

    // Warehouse extras
    addStock: 'Add Stock',
    returnStock: 'Return Stock',
    stockForecast: 'Stock Forecast',
    transactionHistory: 'Transaction History',
    expiry: 'Expiry',
    expired: 'Expired',
    batchNote: 'Batch/Note',
    currentStock: 'Current Stock',
    warehouseManagement: 'Warehouse Management',
    inventoryForecast: 'Inventory & forecast management',

    // Products extras
    performance: 'Performance',
    penetrationTab: 'Penetration',
    productAnalytics: 'Product Analytics',
    salesPerformance: 'Sales & performance analysis',
    totalPRValue: 'Total PR Value',
    totalBonusValue: 'Total Bonus Value',
    avgPrice: 'Avg Price',
    penetrationRate: 'Penetration Rate',

    // Month Closing
    closeMonth: 'Close Month',
    openMonth: 'Open Month',
    closed: 'Closed',
    open: 'Open',
    monthStatus: 'Month Status',

    // Deliveries extras
    deliveryLog: 'Delivery Log',
    invoiceRegister: 'Invoice Register',
    deliveryPriority: 'Delivery Priority',
    invoiceNo: 'Invoice No',
    amount: 'Amount',
    deliveriesAndInvoices: 'Deliveries & Invoices',
    trackDeliveries: 'Track deliveries, invoices and priority',

    // Payments extras
    paymentsAndCredit: 'Payments & Credit',
    creditOverview: 'Credit overview and payment tracking',
    paymentHistory: 'Payment History',
    addPayment: 'Add Payment',
    paymentMethod: 'Payment Method',
    cash: 'Cash',

    // Catalog extras
    catalogManagement: 'Catalog Management',
    manageProducts: 'Manage products and pricing rules',
    addNew: 'Add New',
    active: 'Active',
    inactive: 'Inactive',

    // District Summary extras
    districtOverview: 'District Overview',
    summaryByDistrict: 'Summary by district for selected state',

    // Growth extras
    growthComparison: 'Growth Comparison',
    compareGrowth: 'Compare growth across months',

    // Inventory Risk extras
    inventoryRiskAnalysis: 'Inventory Risk Analysis',
    deadStockIdentification: 'Dead stock identification and risk assessment',
    deadStock: 'Dead Stock',
    slowMoving: 'Slow Moving',
    healthy: 'Healthy',

    // Settings extras
    userManagement: 'User Management',
    rolePermissions: 'Role Permissions',
    dataBackupRestore: 'Data Backup & Restore',
    addUser: 'Add User',
    editUser: 'Edit User',
    email: 'Email',
    assignedState: 'Assigned State',
    assignedDistrict: 'Assigned District',
    permissions: 'Permissions',

    // CT Variance
    stockVarianceAlerts: 'Stock Variance Alerts',
    varianceDetail: 'Variance Detail',
    expected: 'Expected',
    actual: 'Actual',
    flagged: 'Flagged',
    critical: 'Critical',
    warning: 'Warning',
    allClear: 'All Clear',
    varianceSettings: 'Variance Settings',
    highSoldThreshold: 'High Sold % Threshold',
    minUnitsForAlert: 'Minimum Units for Alert',

    // MR Mobile
    mrFieldDashboard: 'Field Dashboard',
    mrTodaysRoute: "Today's Route",
    mrVisited: 'visited',
    mrAptekas: 'APTEKAS',
    mrCheckInHere: 'Check In Here',
    mrCheckedIn: 'Checked in',
    mrGettingLocation: 'Getting location...',
    mrCheckingIn: 'Checking in...',
    mrRetryCheckIn: 'Retry Check-In',
    mrProducts: 'PRODUCTS',
    mrPending: 'PENDING',
    mrDelivery: 'DELIVERY',
    mrSold: 'SOLD',
    mrAccount: 'Account',
    mrDeliveryTab: 'Delivery',
    mrOrders: 'Orders',
    mrVisits: 'Visits',
    mrPayments: 'Payments',
    mrP2P: 'P2P',
    mrCatalog: 'Catalog',
    mrIntel: 'Intel',
    mrAllTabs: 'All Tabs',
    mrSwitchFeatures: 'Switch between features',
    mrStockPayment: 'Stock & payment overview',
    mrDeliveryTracking: 'Delivery tracking',
    mrOrderManagement: 'Active order management',
    mrActivityLog: 'Activity & check-in log',
    mrCollectPayments: 'Collect & record payments',
    mrP2PTracking: 'Promise-to-Pay tracking',
    mrBrowseOrder: 'Browse & order products',
    mrCreditRisk: 'Credit risk & alerts',
    mrPayment: 'Payment',
    mrSave: 'Save',
    mrPDF: 'PDF',
    mrNoAptekas: 'No aptekas assigned',
    mrSelectApteka: 'Select apteka',
    mrPerformance: 'Performance',
    mrPerfOverview: 'Performance overview',
    mrPerfAptekas: 'APTEKAS',
    mrPerfCoverage: 'COVERAGE',
    mrPerfCollected: 'COLLECTED',
    mrPerfPayable: 'PAYABLE',
    mrPerfVisitedToday: 'visited today',
    mrPerfVisitedMonth: 'this month',
    mrPerfRate: 'rate',
    mrPerfTotalPayable: 'total payable',
    mrPerfCollectionProgress: 'Collection Progress',
    mrPerfDailyVisits: 'Daily Visits',
    mrPerfPaymentMethods: 'Payment Methods',
    mrPerfRankings: 'Partner Rankings',
    mrPerfPartners: 'partners',
    mrPerfVisitsCount: 'visits',
    mrPerfToday: 'today',
    mrPerfShowAll: 'Show All',
    mrPerfShowLess: 'Show Less',
    mrMonthJan: 'Jan', mrMonthFeb: 'Feb', mrMonthMar: 'Mar', mrMonthApr: 'Apr',
    mrMonthMay: 'May', mrMonthJun: 'Jun', mrMonthJul: 'Jul', mrMonthAug: 'Aug',
    mrMonthSep: 'Sep', mrMonthOct: 'Oct', mrMonthNov: 'Nov', mrMonthDec: 'Dec',
    mrMonthCurrent: 'Current', mrMonthNext: 'Next',
  },
  
  tg: {
    // Common - Tajik
    save: 'Захира кардан',
    cancel: 'Бекор кардан',
    delete: 'Нест кардан',
    edit: 'Таҳрир',
    add: 'Илова кардан',
    search: 'Ҷустуҷӯ',
    loading: 'Боркунӣ...',
    noData: 'Маълумот нест',
    all: 'Ҳама',
    total: 'Ҷамъ',
    units: 'Воҳидҳо',
    actions: 'Амалҳо',
    status: 'Ҳолат',
    date: 'Сана',
    month: 'Моҳ',
    
    // Navigation
    dashboard: 'Панели асосӣ',
    aptekaControl: 'Идоракунии дорухона',
    ordersNav: 'Фармоишҳо',
    warehouseOrders: 'Фармоишҳои анбор',
    purchaseOrders: 'Фармоишҳои хариди',
    brain: 'Мағз',
    autopilot: 'Автопилот',
    warehouse: 'Анбор',
    deliveries: 'Таҳвилот ва ҳисобнома',
    payments: 'Пардохтҳо',
    paymentCalendar: 'Тақвими пардохт',
    moneyControl: 'Идоракунии пул',
    inventoryRisk: 'Хатари захира',
    sequenceAudit: 'Аудит нумерации',
    telegramAudit: 'Аудит Telegram',
    catalog: 'Каталог',
    companyCatalog: 'Каталог компании',
    bulkImport: 'Импорт из Excel',
    districtSummary: 'Хулосаи ноҳия',
    growth: 'Афзоиш',
    shareCodeAnalytics: 'Таҳлили рамзҳо',
    rolesPermissions: 'Нақшҳо ва иҷозатҳо',
    monthClosing: 'Пӯшидани моҳ',
    monthOpening: 'Кушодани моҳ',
    auditLog: 'Санҷиш',
    exceptions: 'Истисноҳо',
    platformAdmin: 'Панели платформа',
    controlRoom: 'Маркази идоракунӣ',
    allWorkspaces: 'Ҳамаи корхонаҳо',
    companies: 'Ширкатҳо',
    pharmacies: 'Дорухонаҳо',
    partners: 'Шарикон',
    tickets: 'Даъватномаҳо',
    backup: 'Нусхаи эҳтиётӣ',
    pharmacyDashboard: 'Панели дорухона',
    productIntelligence: 'Тахлили маҳсулот',
    reliabilityScores: 'Холи боварӣ',
    aiInsights: 'AI Тахлил',
    mrDashboard: 'Панели MR',
    diary: 'Рӯзнома',
    subscription: 'Обуна',
    connections: 'Пайвастагиҳо',
    intelligence: 'Тахлилот',
    monthControl: 'Идоракунии моҳ',
    myCatalog: 'Каталоги ман',
    operations: 'Амалиётҳо',
    settings: 'Танзимот',
    notifications: 'Огоҳиномаҳо',
    messages: 'Паёмҳо',
    
    // Dashboard
    totalAptekas: 'Ҳамаи дорухонаҳо',
    totalProducts: 'Ҳамаи маҳсулот',
    totalDeliveries: 'Ҳамаи таҳвилот',
    totalPayments: 'Ҳамаи пардохтҳо',
    monthlyPR: 'Фурӯши моҳона',
    unpaidBalance: 'Қарзи пардохтнашуда',
    
    // Apteka Control
    selectApteka: 'Дорухонаро интихоб кунед',
    selectMonth: 'Моҳро интихоб кунед',
    oldCT: 'Захираи аввалин',
    delivery: 'Таҳвилот',
    transferIn: 'Воридот',
    transferOut: 'Содирот',
    allUnits: 'Ҳама',
    summa: 'Сумма',
    ctEntry: 'Ҳисоби захира',
    pr: 'Фурӯш',
    prSumma: 'Суммаи фурӯш',
    newDelivery: 'Таҳвилоти нав',
    product: 'Маҳсулот',
    carryFwd: 'Интиқол',
    transfer: 'Интиқол',
    sold: 'Фурӯхташуда',
    saved: 'Захира шуд',
    notSaved: 'Захира нашуд',
    clickSave: 'Захираро пахш кунед',
    monthClosed: 'Моҳ пӯшида',
    monthOpen: 'Моҳ кушода',
    paymentSummary: 'Хулосаи пардохт',
    openingBalance: 'Тавозуни оғоз',
    totalPR: 'Ҳамаи фурӯш',
    discount: 'Тахфиф',
    netPayable: 'Маблағи холис',
    totalPaid: 'Ҳамаи пардохтшуда',
    balanceDue: 'Қарзи боқӣ',
    deliverySuggestions: 'Пешниҳодоти таҳвилот',
    daysStock: 'Рӯзҳои захира',
    suggested: 'Пешниҳодшуда',
    urgent: 'Фаврӣ',
    p2pReminder: 'Ваъдаи пардохт',
    promiseDate: 'Санаи ваъда',
    note: 'Қайд',
    phone: 'Телефон',
    recentEdits: 'Таҳрирҳои охирин',
    useToAdd: 'Барои илова + -ро истифода баред',
    noDeliveries: 'Таҳвилот нест',
    editQuantity: 'Таҳрири миқдор',
    
    // Deliveries
    deliveryLog: 'Рӯйхати таҳвилот',
    invoiceRegister: 'Бақайдгирии ҳисобнома',
    deliveryPriority: 'Афзалияти таҳвилот',
    invoiceNo: 'Рақами ҳисобнома',
    amount: 'Маблағ',
    
    // Payments
    paymentHistory: 'Таърихи пардохт',
    addPayment: 'Илова кардани пардохт',
    paymentMethod: 'Усули пардохт',
    cash: 'Нақд',
    transfer: 'Интиқол',
    
    // Diary
    notes: 'Қайдҳо',
    tasks: 'Вазифаҳо',
    visits: 'Боздидҳо',
    activityLog: 'Рӯзномаи фаъолият',
    addNote: 'Илова кардани қайд',
    addTask: 'Илова кардани вазифа',
    logVisit: 'Сабти боздид',
    pendingTasks: 'Вазифаҳои интизорӣ',
    overdue: 'Мӯҳлаташ гузашта',
    dueDate: 'Санаи иҷро',
    priority: 'Афзалият',
    low: 'Паст',
    medium: 'Миёна',
    high: 'Баланд',
    completed: 'Иҷрошуда',
    pending: 'Дар интизорӣ',
    
    // Settings
    users: 'Истифодабарандагон',
    roles: 'Нақшҳо',
    dataManagement: 'Идоракунии маълумот',
    language: 'Забон',
    
    // Filters
    selectCountry: 'Кишварро интихоб кунед',
    allCountries: 'Ҳамаи кишварҳо',
    selectState: 'Вилоятро интихоб кунед',
    selectDistrict: 'Ноҳияро интихоб кунед',
    allStates: 'Ҳамаи вилоятҳо',
    allDistricts: 'Ҳамаи ноҳияҳо',

    // Layout extras
    theme: 'Мавзӯъ',
    collapse: 'Ҷамъ кардан',
    logOut: 'Баромадан',
    role: 'Нақш',

    // Dashboard extras
    activeAptekas: 'Дорухонаҳои фаъол',
    deliveredValue: 'Арзиши таҳвилот',
    prValue: 'Арзиши фурӯш',
    bonusValue: 'Арзиши бонус',
    liveCTValue: 'Арзиши захираи ҷорӣ',
    liveCTUnits: 'Воҳидҳои захираи ҷорӣ',
    collectionPercent: 'Фоизи ҷамъоварӣ',
    prUnits: 'Фурӯш (воҳидҳо)',
    financialOverview: 'Шарҳи молиявӣ',
    collectionStatus: 'Ҳолати ҷамъоварӣ',
    exportCSV: 'Содир кардани CSV',
    executiveOverview: 'Шарҳи иҷроия барои вилоят ва моҳи интихобшуда',
    editsLocked: 'Таҳрирот қулф аст',
    editsActive: 'Таҳрирот фаъол аст',
    alerts: 'Огоҳиҳо',
    p2pReminders: 'Ваъдаҳои пардохт',
    dueOverdue: 'Мӯҳлаташ расида/гузашта',
    noPaymentData: 'Маълумоти пардохт нест',
    noDataAvailable: 'Маълумот дастрас нест',
    addDataToSee: 'Дорухона, маҳсулот ва захираро илова кунед',
    warehouseForecastRisk: 'Хатари пешгӯии анбор',
    lowStockAptekas: 'Дорухонаҳои камзахира',
    lowPenetrationProducts: 'Маҳсулоти камнуфуз',
    productsAtRisk: 'Маҳсулоте, ки хатари камбудӣ доранд',
    aptekasNeedDelivery: 'Дорухонаҳо фаврон ба таҳвилот ниёз доранд',
    productsLowPen: 'Маҳсулот дар <30% дорухонаҳо',
    topAptekasPR: '5 дорухонаи беҳтарин аз рӯи PR',
    topAptekasUnpaid: '5 дорухонаи беҳтарин аз рӯи қарз',
    topProductsPR: '5 маҳсулоти беҳтарин аз рӯи PR',
    topProductsBonus: '5 маҳсулоти беҳтарин аз рӯи бонус',
    name: 'Ном',
    value: 'Арзиш',

    // Apteka Control extras
    aptekaControlPanel: 'Панели идоракунии дорухона',
    stockSalesPayment: 'Идоракунии захира, фурӯш ва пардохт',
    locked: 'Қулф',
    apteka: 'Дорухона',
    district: 'Ноҳия',
    cleared: 'Пардохтшуда',
    deliveryValue: 'Арзиши таҳвилот',
    nextOldCT: 'Захираи аввалини оянда',
    ctCarryInfo: 'Захираи ҷорӣ ҳамчун захираи аввалин барои моҳи оянда интиқол мешавад.',
    recordPayment: 'Сабти пардохт',
    soldPR: 'Фурӯхташуда (фурӯш)',
    afterDiscount: 'Пас аз тахфиф',
    openingBal: 'Тавозуни оғоз',
    fromPrevMonth: 'Аз моҳи гузашта',
    payable: 'Пардохтанӣ',
    paymentPlusOpening: 'Пардохт + Оғоз',
    paid: 'Пардохтшуда',
    collected: 'ҷамъоварӣ',
    opensNextMonth: 'Моҳи оянда кушода мешавад',
    allClear: 'Ҳама пардохтшуда',
    saveChanges: 'Захираи тағйирот',
    noProductsFound: 'Маҳсулот ёфт нашуд. Аввал маҳсулот илова кунед.',
    gps: 'GPS',
    warehouseSource: 'Манбаи анбор',
    selectProduct: 'Маҳсулотро интихоб кунед',
    price: 'Нарх',
    quantity: 'Миқдор',
    addProduct: 'Илова кардани маҳсулот',
    createDelivery: 'Эҷоди таҳвилот',
    noDeliveriesMonth: 'Таҳвилот дар ин моҳ нест',
    noInvoicesMonth: 'Ҳисобнома дар ин моҳ нест',
    noPaymentsMonth: 'Пардохт дар ин моҳ сабт нашудааст',
    mode: 'Усул',
    reference: 'Истинод',
    downloadPDF: 'Боргирии PDF',
    print: 'Чоп',
    saving: 'Захира шуда истодааст...',
    failedToLoad: 'Боркунӣ ноком шуд',
    allSaved: 'Ҳама захира шуд',
    recentDeliveryEdits: 'Таҳрирҳои охирини таҳвилот',
    reason: 'Сабаб',

    // Warehouse extras
    addStock: 'Илова кардани захира',
    returnStock: 'Баргардонидани захира',
    stockForecast: 'Пешгӯии захира',
    transactionHistory: 'Таърихи амалиётҳо',
    expiry: 'Мӯҳлат',
    expired: 'Мӯҳлаташ гузашта',
    batchNote: 'Партия/Қайд',
    currentStock: 'Захираи ҷорӣ',
    warehouseManagement: 'Идоракунии анбор',
    inventoryForecast: 'Идоракунии захира ва пешгӯӣ',

    // Products extras
    performance: 'Самаранокӣ',
    penetrationTab: 'Нуфуз',
    productAnalytics: 'Таҳлили маҳсулот',
    salesPerformance: 'Таҳлили фурӯш ва самаранокӣ',
    totalPRValue: 'Арзиши умумии фурӯш',
    totalBonusValue: 'Арзиши умумии бонус',
    avgPrice: 'Нархи миёна',
    penetrationRate: 'Дараҷаи нуфуз',

    // Month Closing
    closeMonth: 'Пӯшидани моҳ',
    openMonth: 'Кушодани моҳ',
    closed: 'Пӯшида',
    open: 'Кушода',
    monthStatus: 'Ҳолати моҳ',

    // Deliveries extras
    deliveryLog: 'Рӯйхати таҳвилот',
    invoiceRegister: 'Бақайдгирии ҳисобнома',
    deliveryPriority: 'Афзалияти таҳвилот',
    invoiceNo: 'Рақами ҳисобнома',
    amount: 'Маблағ',
    deliveriesAndInvoices: 'Таҳвилот ва ҳисобнома',
    trackDeliveries: 'Пайгирии таҳвилот, ҳисобнома ва афзалият',

    // Payments extras
    paymentsAndCredit: 'Пардохтҳо ва қарз',
    creditOverview: 'Шарҳи қарз ва пайгирии пардохт',
    paymentHistory: 'Таърихи пардохт',
    addPayment: 'Илова кардани пардохт',
    paymentMethod: 'Усули пардохт',
    cash: 'Нақд',

    // Catalog extras
    catalogManagement: 'Идоракунии каталог',
    manageProducts: 'Идоракунии маҳсулот ва қоидаҳои нарх',
    addNew: 'Илова кардани нав',
    active: 'Фаъол',
    inactive: 'Ғайрифаъол',

    // District Summary extras
    districtOverview: 'Шарҳи ноҳия',
    summaryByDistrict: 'Хулоса аз рӯи ноҳия барои вилояти интихобшуда',

    // Growth extras
    growthComparison: 'Муқоисаи афзоиш',
    compareGrowth: 'Муқоисаи афзоиш дар моҳҳо',

    // Inventory Risk extras
    inventoryRiskAnalysis: 'Таҳлили хатари захира',
    deadStockIdentification: 'Муайянкунии захираи мурда ва арзёбии хатар',
    deadStock: 'Захираи мурда',
    slowMoving: 'Суст ҳаракаткунанда',
    healthy: 'Солим',

    // Settings extras
    userManagement: 'Идоракунии истифодабарандагон',
    rolePermissions: 'Иҷозатҳои нақш',
    dataBackupRestore: 'Нусхаи захиравӣ ва барқароркунӣ',
    addUser: 'Илова кардани истифодабаранда',
    editUser: 'Таҳрири истифодабаранда',
    email: 'Почтаи электронӣ',
    assignedState: 'Вилояти таъиншуда',
    assignedDistrict: 'Ноҳияи таъиншуда',
    permissions: 'Иҷозатҳо',

    // CT Variance
    stockVarianceAlerts: 'Огоҳиҳои тафовути захира',
    varianceDetail: 'Тафсилоти тафовут',
    expected: 'Интизорӣ',
    actual: 'Воқеӣ',
    flagged: 'Қайдшуда',
    critical: 'Буҳронӣ',
    warning: 'Огоҳӣ',
    allClear: 'Ҳама дуруст',
    varianceSettings: 'Танзимоти тафовут',
    highSoldThreshold: 'Ҳадди фурӯши баланд %',
    minUnitsForAlert: 'Ҳадди ақали воҳидҳо',
  },
  
  ru: {
    // Common - Russian
    save: 'Сохранить',
    cancel: 'Отмена',
    delete: 'Удалить',
    edit: 'Редактировать',
    add: 'Добавить',
    search: 'Поиск',
    loading: 'Загрузка...',
    noData: 'Нет данных',
    all: 'Все',
    total: 'Итого',
    units: 'Единицы',
    actions: 'Действия',
    status: 'Статус',
    date: 'Дата',
    month: 'Месяц',
    
    // Navigation
    dashboard: 'Панель управления',
    aptekaControl: 'Управление аптекой',
    ordersNav: 'Заказы',
    warehouseOrders: 'Заказы склада',
    purchaseOrders: 'Закупки (PO)',
    brain: 'Мозг',
    warehouse: 'Склад',
    deliveries: 'Доставки и счета',
    payments: 'Платежи и кредит',
    ledger: 'Книга учёта',
    returns: 'Возвраты',
    orders: 'Заказы',
    lowStockAlerts: 'Низкий запас',
    products: 'Продукты',
    inventoryRisk: 'Риск запасов',
    catalog: 'Каталог',
    companyCatalog: 'Каталоги ширкат',
    bulkImport: 'Импорт из Excel',
    districtSummary: 'Сводка по району',
    growth: 'Рост',
    shareCodeAnalytics: 'Аналитика кодов',
    rolesPermissions: 'Роли и разрешения',
    monthClosing: 'Закрытие месяца',
    monthOpening: 'Открытие месяца',
    auditLog: 'Журнал аудита',
    exceptions: 'Исключения',
    platformAdmin: 'Админ платформы',
    controlRoom: 'Центр управления',
    allWorkspaces: 'Все пространства',
    companies: 'Компании',
    pharmacies: 'Аптеки',
    partners: 'Партнёры',
    tickets: 'Заявки',
    backup: 'Резервная копия',
    pharmacyDashboard: 'Панель аптеки',
    productIntelligence: 'Аналитика товаров',
    reliabilityScores: 'Рейтинг надёжности',
    aiInsights: 'AI Аналитика',
    mrDashboard: 'Панель МП',
    diary: 'Дневник',
    subscription: 'Подписка',
    connections: 'Связи',
    intelligence: 'Аналитика',
    monthControl: 'Управление месяцем',
    myCatalog: 'Мой каталог',
    operations: 'Операции',
    settings: 'Настройки',
    notifications: 'Уведомления',
    messages: 'Сообщения',
    
    // Dashboard
    totalAptekas: 'Всего аптек',
    totalProducts: 'Всего продуктов',
    totalDeliveries: 'Всего доставок',
    totalPayments: 'Всего платежей',
    monthlyPR: 'Ежемесячные продажи',
    unpaidBalance: 'Неоплаченный остаток',
    
    // Apteka Control
    selectApteka: 'Выберите аптеку',
    selectMonth: 'Выберите месяц',
    oldCT: 'Начальный остаток',
    delivery: 'Доставка',
    transferIn: 'Приход',
    transferOut: 'Расход',
    allUnits: 'Все',
    summa: 'Сумма',
    ctEntry: 'Учёт запасов',
    pr: 'Продажи',
    prSumma: 'Сумма продаж',
    newDelivery: 'Новая доставка',
    product: 'Продукт',
    carryFwd: 'Перенос',
    transfer: 'Перевод',
    sold: 'Продано',
    saved: 'Сохранено',
    notSaved: 'Не сохранено',
    clickSave: 'нажмите Сохранить',
    monthClosed: 'Месяц закрыт',
    monthOpen: 'Месяц открыт',
    paymentSummary: 'Сводка платежей',
    openingBalance: 'Начальный остаток',
    totalPR: 'Общие продажи',
    discount: 'Скидка',
    netPayable: 'К оплате',
    totalPaid: 'Всего оплачено',
    balanceDue: 'Задолженность',
    deliverySuggestions: 'Рекомендации по доставке',
    daysStock: 'Дней запаса',
    suggested: 'Рекомендуется',
    urgent: 'Срочно',
    p2pReminder: 'Обещание оплаты',
    promiseDate: 'Дата обещания',
    note: 'Заметка',
    phone: 'Телефон',
    recentEdits: 'Последние изменения',
    useToAdd: 'Нажмите + чтобы добавить',
    noDeliveries: 'Нет доставок',
    editQuantity: 'Изменить количество',
    
    // Deliveries
    deliveryLog: 'Журнал доставок',
    invoiceRegister: 'Реестр счетов',
    deliveryPriority: 'Приоритет доставки',
    invoiceNo: 'Номер счета',
    amount: 'Сумма',
    
    // Payments
    paymentHistory: 'История платежей',
    addPayment: 'Добавить платеж',
    paymentMethod: 'Способ оплаты',
    cash: 'Наличные',
    transfer: 'Перевод',
    
    // Diary
    notes: 'Заметки',
    tasks: 'Задачи',
    visits: 'Визиты',
    activityLog: 'Журнал активности',
    addNote: 'Добавить заметку',
    addTask: 'Добавить задачу',
    logVisit: 'Записать визит',
    pendingTasks: 'Ожидающие задачи',
    overdue: 'Просрочено',
    dueDate: 'Срок выполнения',
    priority: 'Приоритет',
    low: 'Низкий',
    medium: 'Средний',
    high: 'Высокий',
    completed: 'Выполнено',
    pending: 'В ожидании',
    
    // Settings
    users: 'Пользователи',
    roles: 'Роли',
    dataManagement: 'Управление данными',
    language: 'Язык',
    
    // Filters
    selectCountry: 'Выберите страну',
    allCountries: 'Все страны',
    selectState: 'Выберите область',
    selectDistrict: 'Выберите район',
    allStates: 'Все области',
    allDistricts: 'Все районы',

    // Layout extras
    theme: 'Тема',
    collapse: 'Свернуть',
    logOut: 'Выйти',
    role: 'Роль',

    activeAptekas: 'Активные аптеки',
    deliveredValue: 'Сумма доставок',
    prValue: 'Сумма продаж',
    bonusValue: 'Сумма бонуса',
    liveCTValue: 'Текущий остаток (сумма)',
    liveCTUnits: 'Текущий остаток (ед.)',
    collectionPercent: 'Сбор %',
    prUnits: 'Продажи (ед.)',
    financialOverview: 'Финансовый обзор',
    collectionStatus: 'Статус сбора',
    exportCSV: 'Экспорт CSV',
    executiveOverview: 'Обзор для выбранной области и месяца',
    editsLocked: 'Редактирование заблокировано',
    editsActive: 'Редактирование активно',
    alerts: 'Уведомления',
    p2pReminders: 'Обещания оплаты',
    dueOverdue: 'К оплате/Просрочено',
    noPaymentData: 'Нет данных о платежах',
    noDataAvailable: 'Нет данных',
    addDataToSee: 'Добавьте аптеки, продукты и запасы',
    warehouseForecastRisk: 'Риск прогноза склада',
    lowStockAptekas: 'Аптеки с низким запасом',
    lowPenetrationProducts: 'Продукты с низким проникновением',
    productsAtRisk: 'Продукты под риском дефицита',
    aptekasNeedDelivery: 'Аптеки срочно нуждаются в доставке',
    productsLowPen: 'Продукты в <30% аптек',
    topAptekasPR: 'Топ 5 аптек по PR',
    topAptekasUnpaid: 'Топ 5 аптек по задолженности',
    topProductsPR: 'Топ 5 продуктов по PR',
    topProductsBonus: 'Топ 5 продуктов по бонусу',
    name: 'Название',
    value: 'Значение',

    aptekaControlPanel: 'Панель управления аптекой',
    stockSalesPayment: 'Управление запасами, продажами и платежами',
    locked: 'Заблокировано',
    apteka: 'Аптека',
    district: 'Район',
    cleared: 'Оплачено',
    deliveryValue: 'Сумма доставки',
    nextOldCT: 'Следующий начальный остаток',
    ctCarryInfo: 'Текущий остаток переносится как начальный остаток на следующий месяц.',
    recordPayment: 'Записать платеж',
    soldPR: 'Продано (продажи)',
    afterDiscount: 'После скидки',
    openingBal: 'Начальный ост.',
    fromPrevMonth: 'С прошлого месяца',
    payable: 'К оплате',
    paymentPlusOpening: 'Платеж + Начальный',
    paid: 'Оплачено',
    collected: 'собрано',
    opensNextMonth: 'Переходит на следующий месяц',
    allClear: 'Все оплачено',
    saveChanges: 'Сохранить изменения',
    noProductsFound: 'Продукты не найдены. Сначала добавьте в каталог.',
    gps: 'GPS',
    warehouseSource: 'Источник склада',
    selectProduct: 'Выберите продукт',
    price: 'Цена',
    quantity: 'Количество',
    addProduct: 'Добавить продукт',
    createDelivery: 'Создать доставку',
    noDeliveriesMonth: 'Нет доставок в этом месяце',
    noInvoicesMonth: 'Нет счетов в этом месяце',
    noPaymentsMonth: 'Нет платежей в этом месяце',
    mode: 'Способ',
    reference: 'Ссылка',
    downloadPDF: 'Скачать PDF',
    print: 'Печать',
    saving: 'Сохранение...',
    failedToLoad: 'Ошибка загрузки',
    allSaved: 'Все сохранено',
    recentDeliveryEdits: 'Последние изменения доставок',
    reason: 'Причина',

    addStock: 'Добавить запас',
    returnStock: 'Вернуть запас',
    stockForecast: 'Прогноз запасов',
    transactionHistory: 'История операций',
    expiry: 'Срок годности',
    expired: 'Просрочено',
    batchNote: 'Партия/Заметка',
    currentStock: 'Текущий запас',
    warehouseManagement: 'Управление складом',
    inventoryForecast: 'Управление запасами и прогнозирование',

    performance: 'Эффективность',
    penetrationTab: 'Проникновение',
    productAnalytics: 'Аналитика продуктов',
    salesPerformance: 'Анализ продаж и эффективности',
    totalPRValue: 'Общая сумма продаж',
    totalBonusValue: 'Общая сумма бонуса',
    avgPrice: 'Средняя цена',
    penetrationRate: 'Уровень проникновения',

    closeMonth: 'Закрыть месяц',
    openMonth: 'Открыть месяц',
    closed: 'Закрыт',
    open: 'Открыт',
    monthStatus: 'Статус месяца',

    deliveriesAndInvoices: 'Доставки и счета',
    trackDeliveries: 'Отслеживание доставок, счетов и приоритетов',
    paymentsAndCredit: 'Платежи и кредит',
    creditOverview: 'Обзор кредитов и отслеживание платежей',
    catalogManagement: 'Управление каталогом',
    manageProducts: 'Управление продуктами и ценообразованием',
    addNew: 'Добавить новый',
    active: 'Активный',
    inactive: 'Неактивный',
    districtOverview: 'Обзор по районам',
    summaryByDistrict: 'Сводка по районам для выбранной области',
    growthComparison: 'Сравнение роста',
    compareGrowth: 'Сравнение роста по месяцам',
    inventoryRiskAnalysis: 'Анализ рисков запасов',
    deadStockIdentification: 'Мертвые запасы и оценка рисков',
    deadStock: 'Мертвый запас',
    slowMoving: 'Медленно движущийся',
    healthy: 'Здоровый',
    userManagement: 'Управление пользователями',
    rolePermissions: 'Права ролей',
    dataBackupRestore: 'Резервное копирование и восстановление',
    addUser: 'Добавить пользователя',
    editUser: 'Редактировать пользователя',
    email: 'Эл. почта',
    assignedState: 'Назначенная область',
    assignedDistrict: 'Назначенный район',
    permissions: 'Разрешения',

    // CT Variance
    stockVarianceAlerts: 'Оповещения об отклонениях запасов',
    varianceDetail: 'Детали отклонения',
    expected: 'Ожидаемое',
    actual: 'Фактическое',
    flagged: 'Отмечено',
    critical: 'Критично',
    warning: 'Предупреждение',
    allClear: 'Всё в порядке',
    varianceSettings: 'Настройки отклонений',
    highSoldThreshold: 'Порог высоких продаж %',
    minUnitsForAlert: 'Мин. единиц для оповещения',

    // MR Mobile
    mrFieldDashboard: 'Полевая панель',
    mrTodaysRoute: 'Маршрут на сегодня',
    mrVisited: 'посещено',
    mrAptekas: 'АПТЕКИ',
    mrCheckInHere: 'Отметиться здесь',
    mrCheckedIn: 'Отмечен',
    mrGettingLocation: 'Определение местоположения...',
    mrCheckingIn: 'Отметка...',
    mrRetryCheckIn: 'Повторить отметку',
    mrProducts: 'ПРОДУКТЫ',
    mrPending: 'ОЖИДАНИЕ',
    mrDelivery: 'ДОСТАВКА',
    mrSold: 'ПРОДАНО',
    mrAccount: 'Счёт',
    mrDeliveryTab: 'Доставка',
    mrOrders: 'Заказы',
    mrVisits: 'Визиты',
    mrPayments: 'Платежи',
    mrP2P: 'П2П',
    mrCatalog: 'Каталог',
    mrIntel: 'Аналитика',
    mrAllTabs: 'Все вкладки',
    mrSwitchFeatures: 'Переключение между функциями',
    mrStockPayment: 'Запасы и оплата',
    mrDeliveryTracking: 'Отслеживание доставок',
    mrOrderManagement: 'Управление заказами',
    mrActivityLog: 'Журнал визитов',
    mrCollectPayments: 'Сбор платежей',
    mrP2PTracking: 'Обещания оплаты',
    mrBrowseOrder: 'Просмотр и заказ товаров',
    mrCreditRisk: 'Кредитные риски',
    mrPayment: 'Платёж',
    mrSave: 'Сохранить',
    mrPDF: 'PDF',
    mrNoAptekas: 'Нет назначенных аптек',
    mrSelectApteka: 'Выберите аптеку',
    mrPerformance: 'Показатели',
    mrPerfOverview: 'Обзор показателей',
    mrPerfAptekas: 'АПТЕКИ',
    mrPerfCoverage: 'ОХВАТ',
    mrPerfCollected: 'СОБРАНО',
    mrPerfPayable: 'К ОПЛАТЕ',
    mrPerfVisitedToday: 'посещено сегодня',
    mrPerfVisitedMonth: 'за месяц',
    mrPerfRate: 'ставка',
    mrPerfTotalPayable: 'всего к оплате',
    mrPerfCollectionProgress: 'Прогресс сбора',
    mrPerfDailyVisits: 'Ежедневные визиты',
    mrPerfPaymentMethods: 'Способы оплаты',
    mrPerfRankings: 'Рейтинг партнёров',
    mrPerfPartners: 'партнёров',
    mrPerfVisitsCount: 'визитов',
    mrPerfToday: 'сегодня',
    mrPerfShowAll: 'Показать все',
    mrPerfShowLess: 'Показать меньше',
    mrMonthJan: 'Янв', mrMonthFeb: 'Фев', mrMonthMar: 'Мар', mrMonthApr: 'Апр',
    mrMonthMay: 'Май', mrMonthJun: 'Июн', mrMonthJul: 'Июл', mrMonthAug: 'Авг',
    mrMonthSep: 'Сен', mrMonthOct: 'Окт', mrMonthNov: 'Ноя', mrMonthDec: 'Дек',
    mrMonthCurrent: 'Текущий', mrMonthNext: 'Следующий',
  },
  
  uz: {
    // Common - Uzbek
    save: 'Saqlash',
    cancel: 'Bekor qilish',
    delete: "O'chirish",
    edit: 'Tahrirlash',
    add: "Qo'shish",
    search: 'Qidirish',
    loading: 'Yuklanmoqda...',
    noData: "Ma'lumot yo'q",
    all: 'Hammasi',
    total: 'Jami',
    units: 'Birliklar',
    actions: 'Harakatlar',
    status: 'Holat',
    date: 'Sana',
    month: 'Oy',
    
    // Navigation
    dashboard: 'Boshqaruv paneli',
    aptekaControl: 'Dorixona boshqaruvi',
    brain: 'Miya',
    warehouse: 'Ombor',
    deliveries: 'Yetkazib berish va hisob-fakturalar',
    payments: "To'lovlar va kredit",
    products: 'Mahsulotlar',
    inventoryRisk: 'Inventar xavfi',
    catalog: 'Katalog',
    companyCatalog: 'Kompaniya katalogi',
    bulkImport: 'Excel import',
    districtSummary: 'Tuman xulosasi',
    growth: "O'sish",
    shareCodeAnalytics: 'Kod tahlili',
    rolesPermissions: 'Rollar va ruxsatlar',
    monthClosing: 'Oyni yopish',
    monthOpening: 'Oyni ochish',
    auditLog: 'Audit jurnali',
    exceptions: 'Istisnolar',
    platformAdmin: 'Platforma admin',
    controlRoom: 'Boshqaruv markazi',
    allWorkspaces: 'Barcha ishxonalar',
    companies: 'Kompaniyalar',
    pharmacies: 'Dorixonalar',
    partners: 'Hamkorlar',
    tickets: 'Arizalar',
    backup: 'Zaxira nusxa',
    pharmacyDashboard: 'Dorixona paneli',
    productIntelligence: 'Mahsulot tahlili',
    reliabilityScores: 'Ishonchlilik bali',
    aiInsights: 'AI Tahlil',
    mrDashboard: 'MR boshqaruv paneli',
    diary: 'Kundalik',
    subscription: 'Obuna',
    connections: 'Ulanishlar',
    intelligence: 'Tahlilot',
    monthControl: 'Oy boshqaruvi',
    myCatalog: 'Mening katalogim',
    operations: 'Amaliyotlar',
    settings: 'Sozlamalar',
    notifications: 'Bildirishnomalar',
    messages: 'Xabarlar',
    
    // Dashboard
    totalAptekas: 'Jami dorixonalar',
    totalProducts: 'Jami mahsulotlar',
    totalDeliveries: 'Jami yetkazib berishlar',
    totalPayments: "Jami to'lovlar",
    monthlyPR: 'Oylik sotuvlar',
    unpaidBalance: "To'lanmagan qoldiq",
    
    // Apteka Control
    selectApteka: 'Dorixonani tanlang',
    selectMonth: 'Oyni tanlang',
    oldCT: 'Boshlang\'ich zaxira',
    delivery: 'Yetkazib berish',
    transferIn: 'Kirim',
    transferOut: 'Chiqim',
    allUnits: 'Hammasi',
    summa: 'Summa',
    ctEntry: 'Zaxira hisobi',
    pr: 'Sotuvlar',
    prSumma: 'Sotuvlar summasi',
    newDelivery: 'Yangi yetkazib berish',
    product: 'Mahsulot',
    carryFwd: "Ko'chirish",
    transfer: "O'tkazma",
    sold: 'Sotilgan',
    saved: 'Saqlandi',
    notSaved: 'Saqlanmadi',
    clickSave: 'Saqlash tugmasini bosing',
    monthClosed: 'Oy yopilgan',
    monthOpen: 'Oy ochiq',
    paymentSummary: "To'lov xulosasi",
    openingBalance: 'Boshlang\'ich qoldiq',
    totalPR: 'Jami sotuvlar',
    discount: 'Chegirma',
    netPayable: "To'lanishi kerak",
    totalPaid: "Jami to'langan",
    balanceDue: 'Qarz qoldig\'i',
    deliverySuggestions: 'Yetkazib berish tavsiyalari',
    daysStock: 'Kunlik zaxira',
    suggested: 'Tavsiya etilgan',
    urgent: 'Shoshilinch',
    p2pReminder: 'To\'lov va\'dasi',
    promiseDate: "Va'da sanasi",
    note: 'Eslatma',
    phone: 'Telefon',
    recentEdits: "So'nggi o'zgarishlar",
    useToAdd: "Qo'shish uchun + bosing",
    noDeliveries: 'Yetkazib berish yo\'q',
    editQuantity: 'Miqdorni tahrirlash',
    
    // Deliveries
    deliveryLog: 'Yetkazib berish jurnali',
    invoiceRegister: 'Hisob-faktura reyestri',
    deliveryPriority: 'Yetkazib berish ustuvorligi',
    invoiceNo: 'Hisob-faktura raqami',
    amount: 'Miqdor',
    
    // Payments
    paymentHistory: "To'lov tarixi",
    addPayment: "To'lov qo'shish",
    paymentMethod: "To'lov usuli",
    cash: 'Naqd',
    transfer: "O'tkazma",
    
    // Diary
    notes: 'Eslatmalar',
    tasks: 'Vazifalar',
    visits: 'Tashriflar',
    activityLog: 'Faoliyat jurnali',
    addNote: "Eslatma qo'shish",
    addTask: "Vazifa qo'shish",
    logVisit: 'Tashrifni qayd etish',
    pendingTasks: 'Kutilayotgan vazifalar',
    overdue: "Muddati o'tgan",
    dueDate: 'Tugash sanasi',
    priority: 'Ustuvorlik',
    low: 'Past',
    medium: "O'rta",
    high: 'Yuqori',
    completed: 'Bajarildi',
    pending: 'Kutilmoqda',
    
    // Settings
    users: 'Foydalanuvchilar',
    roles: 'Rollar',
    dataManagement: "Ma'lumotlarni boshqarish",
    language: 'Til',
    
    // Filters
    selectCountry: 'Mamlakatni tanlang',
    allCountries: 'Barcha mamlakatlar',
    selectState: 'Viloyatni tanlang',
    selectDistrict: 'Tumanni tanlang',
    allStates: 'Barcha viloyatlar',
    allDistricts: 'Barcha tumanlar',

    // Layout extras
    theme: 'Mavzu',
    collapse: 'Yig\'ish',
    logOut: 'Chiqish',
    role: 'Rol',

    activeAptekas: 'Faol dorixonalar',
    deliveredValue: 'Yetkazib berish summasi',
    prValue: 'Sotuvlar summasi',
    bonusValue: 'Bonus summasi',
    liveCTValue: 'Joriy zaxira summasi',
    liveCTUnits: 'Joriy zaxira birliklari',
    collectionPercent: 'Yig\'ish %',
    prUnits: 'Sotuvlar (birlik)',
    financialOverview: 'Moliyaviy sharh',
    collectionStatus: 'Yig\'ish holati',
    exportCSV: 'CSV eksport',
    executiveOverview: 'Tanlangan viloyat va oy uchun sharh',
    editsLocked: 'Tahrirlash bloklangan',
    editsActive: 'Tahrirlash faol',
    alerts: 'Ogohlantirishlar',
    p2pReminders: 'To\'lov va\'dalari',
    dueOverdue: 'To\'lash/Muddati o\'tgan',
    noPaymentData: 'To\'lov ma\'lumotlari yo\'q',
    noDataAvailable: 'Ma\'lumot yo\'q',
    addDataToSee: 'Dorixona, mahsulot va zaxira qo\'shing',
    warehouseForecastRisk: 'Ombor prognoz xavfi',
    lowStockAptekas: 'Kam zaxirali dorixonalar',
    lowPenetrationProducts: 'Kam tarqalgan mahsulotlar',
    productsAtRisk: 'Tanqislik xavfi ostidagi mahsulotlar',
    aptekasNeedDelivery: 'Dorixonalar shoshilinch yetkazib berishga muhtoj',
    productsLowPen: 'Mahsulotlar <30% dorixonalarda',
    topAptekasPR: 'Top 5 dorixona PR bo\'yicha',
    topAptekasUnpaid: 'Top 5 dorixona qarz bo\'yicha',
    topProductsPR: 'Top 5 mahsulot PR bo\'yicha',
    topProductsBonus: 'Top 5 mahsulot bonus bo\'yicha',
    name: 'Nomi',
    value: 'Qiymati',

    aptekaControlPanel: 'Dorixona boshqaruv paneli',
    stockSalesPayment: 'Zaxira, sotuv va to\'lovlarni boshqarish',
    locked: 'Bloklangan',
    apteka: 'Dorixona',
    district: 'Tuman',
    cleared: 'To\'langan',
    deliveryValue: 'Yetkazib berish summasi',
    nextOldCT: 'Keyingi boshlang\'ich zaxira',
    ctCarryInfo: 'Joriy zaxira keyingi oyga boshlang\'ich zaxira sifatida ko\'chiriladi.',
    recordPayment: 'To\'lovni qayd etish',
    soldPR: 'Sotilgan (sotuv)',
    afterDiscount: 'Chegirmadan keyin',
    openingBal: 'Boshlang\'ich qoldiq',
    fromPrevMonth: 'O\'tgan oydan',
    payable: 'To\'lanishi kerak',
    paymentPlusOpening: 'To\'lov + Boshlang\'ich',
    paid: 'To\'langan',
    collected: 'yig\'ilgan',
    opensNextMonth: 'Keyingi oyga o\'tadi',
    allClear: 'Hammasi to\'langan',
    saveChanges: 'O\'zgarishlarni saqlash',
    noProductsFound: 'Mahsulot topilmadi. Avval katalogga qo\'shing.',
    gps: 'GPS',
    warehouseSource: 'Ombor manbasi',
    selectProduct: 'Mahsulotni tanlang',
    price: 'Narx',
    quantity: 'Miqdor',
    addProduct: 'Mahsulot qo\'shish',
    createDelivery: 'Yetkazib berish yaratish',
    noDeliveriesMonth: 'Bu oyda yetkazib berish yo\'q',
    noInvoicesMonth: 'Bu oyda hisob-faktura yo\'q',
    noPaymentsMonth: 'Bu oyda to\'lov qayd etilmagan',
    mode: 'Usul',
    reference: 'Havola',
    downloadPDF: 'PDF yuklab olish',
    print: 'Chop etish',
    saving: 'Saqlanmoqda...',
    failedToLoad: 'Yuklash xatosi',
    allSaved: 'Hammasi saqlandi',
    recentDeliveryEdits: 'So\'nggi yetkazib berish o\'zgarishlari',
    reason: 'Sabab',

    addStock: 'Zaxira qo\'shish',
    returnStock: 'Zaxirani qaytarish',
    stockForecast: 'Zaxira prognozi',
    transactionHistory: 'Operatsiyalar tarixi',
    expiry: 'Yaroqlilik muddati',
    expired: 'Muddati o\'tgan',
    batchNote: 'Partiya/Eslatma',
    currentStock: 'Joriy zaxira',
    warehouseManagement: 'Ombor boshqaruvi',
    inventoryForecast: 'Zaxira boshqaruvi va prognozlash',

    performance: 'Samaradorlik',
    penetrationTab: 'Tarqalish',
    productAnalytics: 'Mahsulot tahlili',
    salesPerformance: 'Sotuv va samaradorlik tahlili',
    totalPRValue: 'Jami sotuvlar summasi',
    totalBonusValue: 'Jami bonus summasi',
    avgPrice: 'O\'rtacha narx',
    penetrationRate: 'Tarqalish darajasi',

    closeMonth: 'Oyni yopish',
    openMonth: 'Oyni ochish',
    closed: 'Yopilgan',
    open: 'Ochiq',
    monthStatus: 'Oy holati',

    deliveriesAndInvoices: 'Yetkazib berish va hisob-fakturalar',
    trackDeliveries: 'Yetkazib berish, hisob-faktura va ustuvorlikni kuzatish',
    paymentsAndCredit: 'To\'lovlar va kredit',
    creditOverview: 'Kredit sharhi va to\'lovlarni kuzatish',
    catalogManagement: 'Katalog boshqaruvi',
    manageProducts: 'Mahsulotlar va narx qoidalarini boshqarish',
    addNew: 'Yangi qo\'shish',
    active: 'Faol',
    inactive: 'Nofaol',
    districtOverview: 'Tuman sharhi',
    summaryByDistrict: 'Tanlangan viloyat uchun tuman bo\'yicha xulosa',
    growthComparison: 'O\'sish taqqoslash',
    compareGrowth: 'Oylar bo\'yicha o\'sishni taqqoslash',
    inventoryRiskAnalysis: 'Inventar xavfi tahlili',
    deadStockIdentification: 'O\'lik zaxira va xavf baholash',
    deadStock: 'O\'lik zaxira',
    slowMoving: 'Sekin harakatlanuvchi',
    healthy: 'Sog\'lom',
    userManagement: 'Foydalanuvchilarni boshqarish',
    rolePermissions: 'Rol ruxsatlari',
    dataBackupRestore: 'Ma\'lumotlarni zaxiralash va tiklash',
    addUser: 'Foydalanuvchi qo\'shish',
    editUser: 'Foydalanuvchini tahrirlash',
    email: 'Elektron pochta',
    assignedState: 'Tayinlangan viloyat',
    assignedDistrict: 'Tayinlangan tuman',
    permissions: 'Ruxsatlar',

    // CT Variance
    stockVarianceAlerts: 'Zaxira farqi ogohlantirishlari',
    varianceDetail: 'Farq tafsilotlari',
    expected: 'Kutilgan',
    actual: 'Haqiqiy',
    flagged: 'Belgilangan',
    critical: 'Muhim',
    warning: 'Ogohlantirish',
    allClear: 'Hammasi yaxshi',
    varianceSettings: 'Farq sozlamalari',
    highSoldThreshold: 'Yuqori sotish chegarasi %',
    minUnitsForAlert: 'Ogohlantirish uchun min birliklar',
  },

  uk: {
    // Common - Ukrainian
    save: 'Зберегти',
    cancel: 'Скасувати',
    delete: 'Видалити',
    edit: 'Редагувати',
    add: 'Додати',
    search: 'Пошук',
    loading: 'Завантаження...',
    noData: 'Немає даних',
    all: 'Усе',
    total: 'Усього',
    units: 'Одиниці',
    actions: 'Дії',
    status: 'Статус',
    date: 'Дата',
    month: 'Місяць',

    // Navigation
    dashboard: 'Панель керування',
    aptekaControl: 'Управління аптекою',
    brain: 'Мозок',
    autopilot: 'Автопілот',
    warehouse: 'Склад',
    deliveries: 'Доставки та рахунки',
    payments: 'Платежі та кредит',
    products: 'Продукти',
    inventoryRisk: 'Ризик запасів',
    catalog: 'Каталог',
    companyCatalog: 'Каталог компанії',
    bulkImport: 'Імпорт з Excel',
    districtSummary: 'Зведення по районах',
    growth: 'Зростання',
    shareCodeAnalytics: 'Аналітика кодів',
    rolesPermissions: 'Ролі та дозволи',
    monthClosing: 'Закриття місяця',
    monthOpening: 'Відкриття місяця',
    auditLog: 'Журнал аудиту',
    exceptions: 'Винятки',
    platformAdmin: 'Адмін платформи',
    controlRoom: 'Центр керування',
    allWorkspaces: 'Всі простори',
    companies: 'Компанії',
    pharmacies: 'Аптеки',
    partners: 'Партнери',
    tickets: 'Заявки',
    backup: 'Резервна копія',
    pharmacyDashboard: 'Панель аптеки',
    productIntelligence: 'Аналітика товарів',
    reliabilityScores: 'Рейтинг надійності',
    aiInsights: 'AI Аналітика',
    mrDashboard: 'Панель МП',
    diary: 'Щоденник',
    settings: 'Налаштування',
    notifications: 'Сповіщення',
    messages: 'Повідомлення',

    // Dashboard
    totalAptekas: 'Усього аптек',
    totalProducts: 'Усього продуктів',
    totalDeliveries: 'Усього доставок',
    totalPayments: 'Усього платежів',
    monthlyPR: 'Щомісячний PR',
    unpaidBalance: 'Несплачений залишок',

    // Apteka Control
    selectApteka: 'Оберіть аптеку',
    selectMonth: 'Оберіть місяць',
    oldCT: 'Старий CT',
    delivery: 'Доставка',
    transferIn: 'Вх.Пер.',
    transferOut: 'Вих.Пер.',
    allUnits: 'Усього',
    summa: 'Сума',
    ctEntry: 'Запис CT',
    pr: 'PR',
    prSumma: 'Сума PR',
    newDelivery: 'Нова доставка',
    product: 'Продукт',
    carryFwd: 'Перенесення',
    transfer: 'Переказ',
    sold: 'Продано',
    saved: 'Збережено',
    notSaved: 'Не збережено',
    clickSave: 'натисніть Зберегти нижче',
    monthClosed: 'Місяць закрито',
    monthOpen: 'Місяць відкрито',
    paymentSummary: 'Підсумок платежів',
    openingBalance: 'Початковий залишок',
    totalPR: 'Загальний PR',
    discount: 'Знижка',
    netPayable: 'До сплати',
    totalPaid: 'Усього сплачено',
    balanceDue: 'Залишок боргу',
    deliverySuggestions: 'Пропозиції доставки',
    daysStock: 'Днів запасу',
    suggested: 'Рекомендовано',
    urgent: 'Терміново',
    p2pReminder: 'P2P нагадування',
    promiseDate: 'Дата обіцянки',
    note: 'Примітка',
    phone: 'Телефон',
    recentEdits: 'Останні зміни',
    useToAdd: 'Натисніть + щоб додати',
    noDeliveries: 'Немає доставок',
    editQuantity: 'Редагувати кількість',
    avgDailyPR: 'Серед. PR/день',

    // Deliveries
    deliveryLog: 'Журнал доставок',
    invoiceRegister: 'Реєстр рахунків',
    deliveryPriority: 'Пріоритет доставки',
    invoiceNo: 'Номер рахунку',
    amount: 'Сума',

    // Payments
    paymentHistory: 'Історія платежів',
    addPayment: 'Додати платіж',
    paymentMethod: 'Спосіб оплати',
    cash: 'Готівка',

    // Diary
    notes: 'Нотатки',
    tasks: 'Завдання',
    visits: 'Візити',
    activityLog: 'Журнал активності',
    addNote: 'Додати нотатку',
    addTask: 'Додати завдання',
    logVisit: 'Записати візит',
    pendingTasks: 'Очікувані завдання',
    overdue: 'Прострочені',
    dueDate: 'Термін виконання',
    priority: 'Пріоритет',
    low: 'Низький',
    medium: 'Середній',
    high: 'Високий',
    completed: 'Виконано',
    pending: 'Очікується',

    // Settings
    users: 'Користувачі',
    roles: 'Ролі',
    dataManagement: 'Управління даними',
    language: 'Мова',

    // Filters
    selectCountry: 'Оберіть країну',
    allCountries: 'Усі країни',
    selectState: 'Оберіть область',
    selectDistrict: 'Оберіть район',
    allStates: 'Усі області',
    allDistricts: 'Усі райони',

    // Layout extras
    theme: 'Тема',
    collapse: 'Згорнути',
    logOut: 'Вийти',
    role: 'Роль',

    // Dashboard extras
    activeAptekas: 'Активні аптеки',
    deliveredValue: 'Сума доставок',
    prValue: 'Сума PR',
    bonusValue: 'Сума бонусу',
    liveCTValue: 'Сума CT',
    liveCTUnits: 'Одиниці CT',
    collectionPercent: 'Збір %',
    prUnits: 'Одиниці PR',
    financialOverview: 'Фінансовий огляд',
    collectionStatus: 'Статус збору',
    exportCSV: 'Експорт CSV',
    executiveOverview: 'Огляд для обраної області та місяця',
    editsLocked: 'Редагування заблоковано',
    editsActive: 'Редагування активне',
    alerts: 'Сповіщення',
    p2pReminders: 'P2P нагадування платежів',
    dueOverdue: 'До сплати/Прострочено',
    noPaymentData: 'Немає даних про платежі',
    noDataAvailable: 'Дані відсутні',
    addDataToSee: 'Додайте аптеки, продукти та запаси',
    warehouseForecastRisk: 'Ризик прогнозу складу',
    lowStockAptekas: 'Аптеки з низьким запасом',
    lowPenetrationProducts: 'Продукти з низьким проникненням',
    productsAtRisk: 'Продукти під загрозою дефіциту',
    aptekasNeedDelivery: 'Аптеки терміново потребують доставки',
    productsLowPen: 'Продукти в <30% аптек',
    topAptekasPR: 'Топ 5 аптек за PR',
    topAptekasUnpaid: 'Топ 5 аптек за заборгованістю',
    topProductsPR: 'Топ 5 продуктів за PR',
    topProductsBonus: 'Топ 5 продуктів за бонусом',
    name: 'Назва',
    value: 'Значення',

    // Apteka Control extras
    aptekaControlPanel: 'Панель управління аптекою',
    stockSalesPayment: 'Управління запасами, продажами та платежами',
    locked: 'Заблоковано',
    apteka: 'Аптека',
    district: 'Район',
    cleared: 'Оплачено',
    deliveryValue: 'Сума доставки',
    nextOldCT: 'Наступний CT',
    ctCarryInfo: 'Поточний CT переноситься як старий CT на наступний місяць.',
    recordPayment: 'Записати платіж',
    soldPR: 'Продано (продажи)',
    afterDiscount: 'Після знижки',
    openingBal: 'Початковий зал.',
    fromPrevMonth: 'З минулого місяця',
    payable: 'До оплати',
    paymentPlusOpening: 'Платіж + Початковий',
    paid: 'Сплачено',
    collected: 'зібрано',
    opensNextMonth: 'Переходить на наступний місяць',
    allClear: 'Все оплачено',
    saveChanges: 'Зберегти зміни',
    noProductsFound: 'Продукти не знайдено. Спочатку додайте до каталогу.',
    gps: 'GPS',
    warehouseSource: 'Джерело складу',
    selectProduct: 'Оберіть продукт',
    price: 'Ціна',
    quantity: 'Кількість',
    addProduct: 'Додати продукт',
    createDelivery: 'Створити доставку',
    noDeliveriesMonth: 'Немає доставок цього місяця',
    noInvoicesMonth: 'Немає рахунків цього місяця',
    noPaymentsMonth: 'Немає платежів цього місяця',
    mode: 'Спосіб',
    reference: 'Посилання',
    downloadPDF: 'Завантажити PDF',
    print: 'Друк',
    saving: 'Збереження...',
    failedToLoad: 'Помилка завантаження',
    allSaved: 'Все збережено',
    recentDeliveryEdits: 'Останні зміни доставок',
    reason: 'Причина',

    // Warehouse extras
    addStock: 'Додати запас',
    returnStock: 'Повернути запас',
    stockForecast: 'Прогноз запасів',
    transactionHistory: 'Історія операцій',
    expiry: 'Термін придатності',
    expired: 'Прострочено',
    batchNote: 'Партія/Примітка',
    currentStock: 'Поточний запас',
    warehouseManagement: 'Управління складом',
    inventoryForecast: 'Управління запасами та прогнозування',

    // Products extras
    performance: 'Ефективність',
    penetrationTab: 'Проникнення',
    productAnalytics: 'Аналітика продуктів',
    salesPerformance: 'Аналіз продажів та ефективності',
    totalPRValue: 'Загальна сума PR',
    totalBonusValue: 'Загальна сума бонусу',
    avgPrice: 'Середня ціна',
    penetrationRate: 'Рівень проникнення',

    // Month Closing
    closeMonth: 'Закрити місяць',
    openMonth: 'Відкрити місяць',
    closed: 'Закрито',
    open: 'Відкрито',
    monthStatus: 'Статус місяця',

    // Deliveries extras
    deliveriesAndInvoices: 'Доставки та рахунки',
    trackDeliveries: 'Відстеження доставок, рахунків та пріоритетів',
    paymentsAndCredit: 'Платежі та кредит',
    creditOverview: 'Огляд кредитів та відстеження платежів',
    catalogManagement: 'Управління каталогом',
    manageProducts: 'Управління продуктами та ціноутворенням',
    addNew: 'Додати новий',
    active: 'Активний',
    inactive: 'Неактивний',
    districtOverview: 'Огляд по районах',
    summaryByDistrict: 'Зведення по районах для обраної області',
    growthComparison: 'Порівняння зростання',
    compareGrowth: 'Порівняння зростання по місяцях',
    inventoryRiskAnalysis: 'Аналіз ризиків запасів',
    deadStockIdentification: 'Мертві запаси та оцінка ризиків',
    deadStock: 'Мертвий запас',
    slowMoving: 'Повільно рухається',
    healthy: 'Здоровий',
    userManagement: 'Управління користувачами',
    rolePermissions: 'Дозволи ролей',
    dataBackupRestore: 'Резервне копіювання та відновлення',
    addUser: 'Додати користувача',
    editUser: 'Редагувати користувача',
    email: 'Ел. пошта',
    assignedState: 'Призначена область',
    assignedDistrict: 'Призначений район',
    permissions: 'Дозволи',

    // CT Variance
    stockVarianceAlerts: 'Сповіщення про відхилення запасів',
    varianceDetail: 'Деталі відхилення',
    expected: 'Очікуване',
    actual: 'Фактичне',
    flagged: 'Позначено',
    critical: 'Критично',
    warning: 'Попередження',
    allClear: 'Все гаразд',
    varianceSettings: 'Налаштування відхилень',
    highSoldThreshold: 'Поріг високих продажів %',
    minUnitsForAlert: 'Мін. одиниць для сповіщення',
  },
};

const languageNames = {
  en: 'English',
  tg: 'Тоҷикӣ',
  ru: 'Русский',
  uz: "O'zbek",
  uk: 'Українська',
};

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [language, setLanguageState] = useState(() => {
    if (typeof window !== 'undefined') {
      return localStorage.getItem('pharmapro_language') || 'en';
    }
    return 'en';
  });

  const setLanguage = (lang) => {
    setLanguageState(lang);
    localStorage.setItem('pharmapro_language', lang);
  };

  const t = (key) => {
    return translations[language]?.[key] || translations.en[key] || key;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t, languageNames, languages: Object.keys(translations) }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}

export { translations, languageNames };
